import { Backdrop, CircularProgress } from '@mui/material';
import Breadcrumbs from "components/ppa-quote/Breadcrumbs";
import HomeLocationsTable from 'components/ppa-quote/HomeLocationsTable';
import UserContext from "Context/UserProvider";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { useApiService } from "../../services/ApiService/ApiService";

function isNull(array: any) {
    if (array === null || array === undefined) {
        return [];
    }
    return array;
}

function BuildQuotePageLocations(props: any) {
    const { userInfo, setUserInfo } = useContext(UserContext);
    const [loading, setLoading] = useState(true);
    const [homeLocationsData, setHomeLocationsData] = useState([]) as any;
    const [isDisabled, setIsDisabled] = useState<boolean>(false);
    const navigate = useNavigate();
    const location = useLocation();
    const quickQuote = location.state.quickQuote; // Receiving quickQuote from the previous page
    const { fetchWithAuth } = useApiService();

    function checking_null_undefined(array: any) {
        if (array === null || array === undefined) {
            return [];
        }
        return array;
    }

    const handleNext = () => {
        navigate("/agree/ppa/quote/build/summary", {
            state: {
                quickQuote: quickQuote, // Passing quickQuote from previous page
            },
        });
    };

    async function fetchLocationData() {
        try {
            const response = await fetchWithAuth('/infrastructure/dwelling/list', {
                method: 'POST',
                body: JSON.stringify({
                    uuid: userInfo.uuid,
                    businessUuid: userInfo.businessUuid
                })
            });

            if (!response.ok) {
                throw new Error('Failed to fetch location data');
            }

            const res_json = await response.json();
            res_json.homeLocations = checking_null_undefined(res_json.homeLocations);

            setHomeLocationsData(res_json.homeLocations.map((e: any) => ({ 
                ...e, 
                id: e.uuid, 
                nearestPublicChargingDistance: e.nearestPublicCharging != null ? 
                    e.nearestPublicChargingDistance < 0.1 ? 
                        "< 0.1 " + userInfo.userProfile.distanceUnitShortDisplayName : 
                        parseInt(e.nearestPublicChargingDistance).toLocaleString() + " " + userInfo.userProfile.distanceUnitShortDisplayName 
                    : "" 
            })));
        } catch (error) {
            console.error('Error fetching location data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchLocationData();
    }, []);

    return (
        <div>
            {/* Breadcrumbs always displayed */}
            <Breadcrumbs currentStep={"Locations"} />

            {/* Loading popup */}
            <Backdrop open={loading} style={{ zIndex: 1300 }} >
                <CircularProgress color="inherit" />
            </Backdrop>

            {!loading && (

                <div className="container-fluid g-0" style={{ marginTop: "24px" }}>
                    <div className="row gy-2">
                        <div className="drag-drop-container">
                            <HomeLocationsTable data={homeLocationsData} />
                            <br />
                            <br />
                            <br />
                            <div className="col-xs-12 col-md-12 col-xl-12">
                                <div>
                                    <div style={{ display: "flex", justifyContent: "center", gap: 50 }}>

                                        <button className="primary-btn" disabled={isDisabled} onClick={handleNext}>
                                            Next
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}


export default BuildQuotePageLocations;
